module.exports = __webpack_public_path__ + "media/images/location_icon-4ffa4f46.png";